import * as tslib_1 from "tslib";
import { AbstractBase } from '../../../core/helpers/abstract-base';
/**
 * Class for the fieldset base
 */
var FieldsetBase = /** @class */ (function (_super) {
    tslib_1.__extends(FieldsetBase, _super);
    /**
     * Constructs a FieldsetBase
     * @param provider FieldsetProvider that contains configuration data.
     */
    function FieldsetBase(provider) {
        var _this = _super.call(this) || this;
        _this.provider = provider;
        /** Gets, set label of field set. */
        _this.label = '';
        return _this;
    }
    return FieldsetBase;
}(AbstractBase));
export { FieldsetBase };
